const lesson_coach = {
  header: 'アートシフトコーチ追加',
  coach_label: 'アートシフトコーチ',
  coach_required: 'アートシフトコーチを入力してください。',
  video_label: '制限ユニット数',
  video_required: '制限ユニット数を入力してください。',
  add: '新規追加',
  all: '全て',
  button: {
    cancel: 'キャンセル',
    add: '保存',
  },
  table: {
    name: 'コーチ名',
    email: 'メールアドレス',
    phone_number: '電話番号',
    total_video: '閲覧できる\nユニット数',
    created_date: '参加日',
  },
  add_coach_dialog: {
    title: 'コーチ重複',
    content: '指定したコーチは既に指定されましたため、他のコーチを指定してください。',
  },
  add_coach_warning: '一括コーチ追加をご指定いただいたため、個別コーチの指定が無効となります。',
  confirm: {
    delete_header: 'コーチ削除の確認',
    delete_body: 'ご指定のコーチを削除すると、コーチに所属する受講生も講座から削除されます。よろしいでしょうか。',
  },
  noti: {
    coach_new_success: 'コーチを追加しました。',
    coach_new_fail: 'コーチを追加できませんでした。',
    coach_delete_success: 'コーチを削除しました。',
    coach_delete_fail: 'コーチを削除できませんでした。',
  },
  validate: {
    student_not_belong_to_coach: '受講生「{{name}}」は指定されたコーチの管理範囲外です。',
    student_filtered_warning: 'コーチの管理範囲外の受講生は追加されませんでした。',
    student_exceed_coach_limit: '受講生「{{name}}」の制限ユニット数（{{studentLimit}}）がコーチ「{{coachName}}」の制限ユニット数（{{coachLimit}}）を超えています。',
    no_coach_before_add_student: 'コーチに対して講座・ユニットの閲覧権限が設定されていないため、受講生への講座・ユニット閲覧権限を設定できません。',
  },
};

export default lesson_coach;
